import React from 'react';
import EnquiryRow from './EnquiryRow';
import styles from './Enquiries.module.css';

const EnquiriesTable = ({ enquiries, onRowClick }) => {
  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableWrapper}>
        <table className={styles.dataTable}>
          <thead>
            <tr>
              <th>Status</th>
              <th>Project Details</th>
              <th>Customer</th>
              <th>Budget</th>
              <th>Received</th>
            </tr>
          </thead>
          <tbody>
            {enquiries.map((enquiry) => (
              <EnquiryRow
                key={enquiry.id}
                enquiry={enquiry}
                onRowClick={onRowClick}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EnquiriesTable;